<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 18:17:31
-->
<template>
  <veStuCheckModify viewType="admin" slot="table"></veStuCheckModify>
</template>

<script>
import veStuCheckModify from './base/veStuCheckModify';
export default {
  components: {
    veStuCheckModify
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
